var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 9H11.6667C10.5621 9 9.66669 9.89543 9.66669 11V20C9.66669 21.1046 10.5621 22 11.6667 22H20.6667C21.7713 22 22.6667 21.1046 22.6667 20V11C22.6667 9.89543 21.7713 9 20.6667 9Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66669 15H4.66669C4.13625 15 3.62755 14.7893 3.25247 14.4142C2.8774 14.0391 2.66669 13.5304 2.66669 13V4C2.66669 3.46957 2.8774 2.96086 3.25247 2.58579C3.62755 2.21071 4.13625 2 4.66669 2H13.6667C14.1971 2 14.7058 2.21071 15.0809 2.58579C15.456 2.96086 15.6667 3.46957 15.6667 4V5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b77317d49a30d3e59e21608cd92c0579.svg";
export { ForwardRef as ReactComponent };